// /* main js */
import {Modal, Tabs, Collapse} from "bootstrap";
import scrollHandler from "./scrollHandler";
import scrollObserver from "./scrollObserver";
import parallax from "./parallax";
import {startPageOnTop, parents} from "./utilities";
import "./swiperHandler"; // run swiper by using data-swiper attribute
import lozad from "lozad";
import imagesLoaded from 'imagesloaded';

window.addEventListener('DOMContentLoaded', () => {
    startPageOnTop();
    scrollHandler();

    /**
     * Lazy load
     */
    const lazyItems = document.querySelectorAll('.lazy');
    if (lazyItems.length) {
        let options = {
            loaded: function (el) {
                imagesLoaded(el, () => el.parentNode.classList.add('media-loaded'));
                if (!el.alt && el.dataset.alt) el.alt = el.dataset.alt;
            }
        };
        const observer = lozad(lazyItems, options);
        observer.observe();
    }

    /**
     * Is in viewport
     */
    const isInViewportItems = document.querySelectorAll('.is-in-viewport');
    if (isInViewportItems?.length) {
        scrollObserver({ items: isInViewportItems });
    }

    /**
     * Parallax
     */
    const parallaxItems = document.querySelectorAll('.parallax');
    if (parallaxItems?.length) {
        parallax(parallaxItems);
    }

    /**
     * CF7 custom submit
     */
    const wpcf7FormReplaceSubmit = document.querySelector('.wpcf7-form-replace-submit');
    const wpcf7Form = document.querySelector('.wpcf7-form');
    if (wpcf7FormReplaceSubmit && wpcf7Form) {
        wpcf7FormReplaceSubmit.addEventListener('click', () => wpcf7Form.submit());
    }

    /**
     * Event slider (block)
     */
    const eventSlider = document.querySelector('.event-slider');
    if (eventSlider) {
        import("./eventSlider").then(module => {
            module.default(eventSlider);
        });
    }

    /**
     * Expanding cards (block)
     */
    const expandingCards = document.querySelectorAll('.expanding-card');
    if (expandingCards?.length) {
        import("./expandingCards").then(module => {
            module.default(expandingCards);
        });
    }
})



/**
 * menu header desktop
 */
/*
document.addEventListener('DOMContentLoaded', function () {

    const mainNavLinks = document.querySelectorAll('#main > a.nav-link[data-bs-toggle="collapse"]');

    mainNavLinks.forEach(clickedLink => {
        clickedLink.addEventListener('click', function () {
            mainNavLinks.forEach(otherLink => {
                if (otherLink !== clickedLink) {
                    if (otherLink.getAttribute('aria-expanded') === 'true') {
                        otherLink.click();
                    }
                }
            });
        });
    });
});
*/

/**
 * All'apertura di un dropdown prima chiude i precedenti dropdown aperti
 */
let clickedNavLink = null;
document.body.addEventListener('click', (e) => {
    if (e.target.closest('a.nav-link[data-bs-toggle="collapse"]')) {
        e.preventDefault();
        const collapseShow = document.querySelector('.collapse.show');
        if (!collapseShow) return;
        const instance = Collapse.getInstance(collapseShow) || new Collapse(collapseShow, { toggle: false });
        instance.hide();
        clickedNavLink = e.target;
    }
});

/**
 * Chiusura dei collapse del menu header al click fuori dalla loro area
 */
document.addEventListener('DOMContentLoaded', function () {
    const megaMenuCollapses = document.querySelectorAll('.collapse[data-bs-parent="#megamenu-collapses"]');
    const backdropElement = document.querySelector('.megamenu-backdrop');

    if (backdropElement) {
        backdropElement.addEventListener('click', function () {
            megaMenuCollapses.forEach(collapseEl => {
                if (collapseEl.classList.contains('show')) {
                    collapseEl.classList.remove('show');

                    const triggerLink = document.querySelector(`a[data-bs-toggle="collapse"][href="#${collapseEl.id}"]`);
                    if (triggerLink) {
                        triggerLink.setAttribute('aria-expanded', 'false');
                    }
                }
            });
            backdropElement.classList.remove('show');
        });
    }
    megaMenuCollapses.forEach(collapseEl => {
        collapseEl.addEventListener('show.bs.collapse', function () {
            if (backdropElement && !backdropElement.classList.contains('show')) {
                backdropElement.classList.add('show');
            }
        });
        collapseEl.addEventListener('hidden.bs.collapse', function (e) {
            console.log('yes')
            /*setTimeout(() => {
                const anyCollapseStillOpen = Array.from(megaMenuCollapses).some(el => el.classList.contains('show'));
                console.log(anyCollapseStillOpen)
                if (!anyCollapseStillOpen && backdropElement.classList.contains('show')) {
                    backdropElement.classList.remove('show');
                }
            }, 150);*/
        });
    });
});


/**
 * Mobile menu
 */
const menuButton = document.getElementById('menuButton');
const offcanvasRight = document.querySelector('#offcanvasRight');
offcanvasRight.addEventListener('show.bs.offcanvas', event => {
    menuButton.classList.add('is-active');
    headerNavbar.classList.add('navbar-dark');
});
offcanvasRight.addEventListener('hide.bs.offcanvas', event => {
    menuButton.classList.remove('is-active');
    if (window.scrollY > 100 || !headerNavbar.parentElement.classList.contains('has-navbar-dark')) {
        headerNavbar.classList.remove('navbar-dark');
    }
});
const offcanvasNavLinks = offcanvasRight.querySelectorAll('.nav-link');
if (offcanvasNavLinks.length) {
    offcanvasNavLinks.forEach(navLink => {
        navLink.addEventListener('click', (e) => {
            if (!navLink.parentNode.classList.contains('dropdown')) {
                return;
            }
            e.preventDefault();
            e.stopPropagation();
            const clickedElement = e.currentTarget;
            const linkText = clickedElement.textContent.trim();
            const btnBack = document.createElement('button');
            const siblingDropdownMenu = e.target.parentNode.querySelector('.dropdown-menu');

            btnBack.setAttribute('class', 'btn btn-back btn-reset subnav-link d-flex align-items-center mb-7');
            btnBack.setAttribute('role', 'button');
            btnBack.innerText = linkText;
            btnBack.addEventListener('click', () => {
                siblingDropdownMenu.classList.toggle('show');
            });
            if (siblingDropdownMenu && siblingDropdownMenu.classList.contains('dropdown-menu')) {
                if (siblingDropdownMenu.querySelector('.dropdown-title')) {
                    siblingDropdownMenu.querySelector('.dropdown-title').remove();
                }
                if (siblingDropdownMenu.querySelector('.btn-back')) {
                    siblingDropdownMenu.querySelector('.btn-back').remove();
                }
                siblingDropdownMenu.prepend(btnBack);
            }
        });
    });
}

/**
 * Aggiunge una classe agli item del menu offcanvas che hanno un sottomenu,
 * per poter aggiungere l'after con la freccia).
 */
document.addEventListener('DOMContentLoaded', function () {
    const offcanvasMenu = document.querySelector('#offcanvasRight ul.offcanvas-menu');

    if (offcanvasMenu) {
        const dropdownItems = offcanvasMenu.querySelectorAll(':scope > li.nav-item.dropdown');

        dropdownItems.forEach(item => {
            const subMenu = item.querySelector('.dropdown-menu');
            if (subMenu) {
                item.classList.add('has-submenu');
            }
        });
    } else {
    }
});


document.addEventListener('DOMContentLoaded', function () {
    const megamenuCollapses = document.querySelectorAll('#idee-vacanza, #cosa-vedere, #organizza-viaggio');
    let backdropElement = document.querySelector('.megamenu-backdrop');
    let activeMegamenuCount = 0;

    if (!backdropElement) {
        backdropElement = document.createElement('div');
        backdropElement.className = 'megamenu-backdrop';
        document.body.appendChild(backdropElement);
    }

    megamenuCollapses.forEach(collapseEl => {
        collapseEl.addEventListener('show.bs.collapse', function () {
            if (activeMegamenuCount === 0) {
                backdropElement.classList.add('show');
            }
            activeMegamenuCount++;
        });

        collapseEl.addEventListener('hide.bs.collapse', function () {
            activeMegamenuCount--;
            if (activeMegamenuCount === 0) {
                backdropElement.classList.remove('show');
            }
        });
    });

    backdropElement.addEventListener('click', function () {
        megamenuCollapses.forEach(collapseEl => {
            const collapseInstance = Collapse.getInstance(collapseEl);
            if (collapseInstance && collapseEl.classList.contains('show')) {
                collapseInstance.hide();
            }
        });
    });
});


// footer - accordion su mobile
document.addEventListener('DOMContentLoaded', function () {
    function handleFooterAccordions() {
        const isDesktop = window.innerWidth >= 992;
        const footerAccordions = document.querySelectorAll('footer .accordion');

        footerAccordions.forEach(accordion => {
            const parentId = accordion.id;
            const collapseElements = accordion.querySelectorAll('.accordion-collapse');
            const accordionButtons = accordion.querySelectorAll('.accordion-button');

            collapseElements.forEach((collapse, index) => {
                const button = accordionButtons[index];

                if (isDesktop) {
                    collapse.removeAttribute('data-bs-parent');

                    const instance = Collapse.getOrCreateInstance(collapse);
                    instance.show();

                    if (button) {
                        button.removeAttribute('data-bs-toggle');
                        button.removeAttribute('aria-expanded');
                        button.classList.remove('collapsed');

                        button.style.pointerEvents = 'none';
                    }
                } else {
                    collapse.setAttribute('data-bs-parent', `#${parentId}`);

                    const instance = Collapse.getOrCreateInstance(collapse);
                    instance.hide();

                    if (button) {
                        button.setAttribute('data-bs-toggle', 'collapse');
                        button.setAttribute('aria-expanded', 'false');
                        button.classList.add('collapsed');
                        button.style.pointerEvents = 'auto';
                    }
                }
            });
        });
    }

    handleFooterAccordions();
    window.addEventListener('resize', handleFooterAccordions);
});

